import Account from "@/plugins/api/factories/Account";
import Auth from "@/plugins/api/factories/Auth";
import Settings from "@/plugins/api/factories/Settings";
import appBridge from "@/mixins/app-bridge";
// import axios from "axios";
import api from "@/plugins/api/EntryPoint";
import router from "@/router";
import axios from "axios";
import store from "@/store";

export const state = {
  hidden: false,
  guest: false,
  authLog: "",
  nativeData: null,
  authToken: null,
  appTheme: "dark",
  themeReady: false,
  accounts: {},
  account: null,
  balances: null,
  total: null,
  eic: null,
  accountNumber: null,
  phoneNumber: null,
  locale: process.env.VUE_APP_I18N_DEFAULT_LOCALE,
  requestedPage: null,
  advertisement: false,
  status: 0,
  status_sub: 0,
  share_status: 0,
  user_id: null,
  isPreloaded: false,
  phoneLoaded: false,
};

export const mutations = {
  WRITE_AUTH_LOG(state, logString) {
    state.authLog = state.authLog + ";" + logString;
  },
  SET_APP_THEME(state, appTheme) {
    document.body.classList.remove("app-theme-" + state.appTheme);
    state.appTheme = appTheme;
    state.themeReady = true;
    document.body.classList.add("app-theme-" + appTheme);

    Settings.setTheme(appTheme);
  },
  CHANGE_USER_THEME(state, theme) {
    Settings.setTheme(theme);
  },
  SET_REQUESTED_PAGE(state, requestedPage) {
    state.requestedPage = requestedPage;
  },
  SET_ACCOUNT_NUMBER(state, accountNumber) {
    state.accountNumber = accountNumber;
  },
  SET_NATIVE_DATA(state, nativeData) {
    state.nativeData = nativeData;
  },
  SET_AUTH_TOKEN(state, token) {
    state.authToken = token;
  },
  SET_USER_STATUS(state, status){
    state.status = status;
  },
  SET_USER_STATUS_SUB(state, status_sub){
    state.status_sub = status_sub;
  },
  SET_USER_SHARE_STATUS(state, share_status){
    state.share_status = share_status;
    console.log("SET_USER_SHARE_STATUS: " + JSON.stringify(state.share_status))
  },
  SET_USER_ID(state, user_id){
    state.user_id = user_id;
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts;
  },
  SET_BALANCES(state, balances) {
    state.balances = balances;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_PHONE_NUMBER(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
  SET_LOCALE(state, locale) {
    let locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(",");
    if (locales.indexOf(locale) >= 0) {
      state.locale = locale;
    } else {
      state.locale = process.env.VUE_APP_I18N_DEFAULT_LOCALE;
    }
  },
  SET_ACCOUNT(state, account) {
    state.account = account;
  },
  SET_EIC(state, account) {
    state.eic = account;
  },
  SET_GUEST(state, guest) {
    state.guest = guest;
  },
  SET_HIDDEN(state, hidden) {
    state.hidden = hidden;
  },
  SET_ADVERTISEMENT(state, advertisement) {
    state.advertisement = advertisement;
  },
  SET_PHONE_LOADED (state, value) {
    state.phoneLoaded = value;
  }
};

export const getters = {
  nativeData(state) {
    return state.nativeData;
  },
};

export const actions = {
  async authenticate({ commit, dispatch, state }, authData) {
    commit("SET_NATIVE_DATA", authData);
    if(authData.agreement === true) {
      state.advertisement = true;
    }
    dispatch("newNativeData");
  },
  async storeGuest({ state }, callBackFn) {
    Account.guestMode(state.guest, (res) => {
      callBackFn(res);
    });
  },
  async getGuest({ commit }) {
    await Account.getGuestMode((response) => {
      commit("SET_GUEST", response.guest);
    });
  },
  async setupUserSettings({ dispatch, commit, state }) {
    await Settings.getLanguage(async (lang) => {
      let selectedLocale;
      if (lang.language === null) {
        await Settings.putLanguage(state.nativeData.lang);
        selectedLocale = state.nativeData.lang;
      } else {
        selectedLocale = lang.language;
      }
      commit("SET_LOCALE", selectedLocale);
      commit("Settings/UPDATE_LANGUAGE", selectedLocale, { root: true });
    });
    await Auth.getPhoneNumber((response) => {
      console.log(JSON.stringify("getPhoneNumber: " + response.phone))
      commit("SET_PHONE_NUMBER", response.phone);
      commit("SET_PHONE_LOADED", true);
      this.phoneLoaded = true;
    });
    dispatch("getAndSetupTheme");
  },
  async setUserPhone({ state, commit }) {
    console.log("TRY TO SET PHONE");
    if (state.authToken !== null && state.authToken !== undefined) {
      await Auth.getPhoneNumber((response) => {
        console.log("SET PHONE: " + response.phone);
        commit("SET_PHONE_NUMBER", response.phone);
        window.Tawk_API.setAttributes({
          phone: response.phone,
          link: "https://support.billing.city/user/" + response.id,
        });
      });
    }
  },
  async getAndSetupTheme({ commit, state }, theme) {
    await Settings.getTheme((res) => {
      state.themeReady = false;
      const themeToSetup = res.theme ? res.theme : theme ? theme : "dark";
      commit("SET_APP_THEME", themeToSetup);
      appBridge.methods.nativeSendEvent("setThemeMode", themeToSetup);
    });
  },
  async refreshToken({ commit }) {
    return Account.refreshToken((response) => {
      commit("SET_AUTH_TOKEN", response.access_token);
    });
  },
  async importAccounts() {
    return Account.importAccounts((res) => {
      return res.mode;
    });
  },
  async getUserAccounts({ commit }) {
    return Account.getAccounts((response) => {
      return commit("SET_ACCOUNTS", response);
    });
  },
  getUserAccount({ commit }, account) {
    return Account.getAccount(account, (response) => {
      console.log("GET USER ACCOUNT CHECK: " + JSON.stringify(response))
      commit("SET_ACCOUNT", response);
      commit("SET_EIC", response);
      commit("Payment/UPDATE_AMOUNT", response.balance, { root: true });
      commit("IndicationsHistory/SET_TARIFF", response.tariff, { root: true });
    });
  },
  getUserBalances(ctx, data) {
    store.commit("Api/showLoader");
    ctx.commit('SET_TOTAL', null);
    return axios(`https://proc.billing.city/api/get-balance/${data.ls}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
        .then((response) => {
          let total = 0;
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].service_name === 'Електропостачання') {
              response.data.splice(i, 1);
            }
          }
          for (let i = 0; i < response.data.length; i++) {
            if(response.data[i].company_name.includes("Нафтогаз") === true){
              store.commit("Payment/SET_GAS_LS", response.data[i].service_account);
            }
            response.data[i].checked = false;
            if(response.data[i].balance > 0){
              total += response.data[i].balance;
              response.data[i].checked = true;
            }
          }
          console.log(JSON.stringify(response.data))
          ctx.commit('SET_TOTAL', total.toFixed(2));
          ctx.commit('SET_BALANCES', response.data)
          store.commit("Api/hideLoader");
        }).catch((error)=> {
          console.log(error)
        })
  },
  updateUserBalances(ctx, data) {
    ctx.commit('SET_TOTAL', null);
    store.commit("Api/showMessage");
    store.commit("Api/showLoader");
    return axios(`https://proc.billing.city/api/get-actual/${data.ls}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
        .then((response) => {
          let total = 0;
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].service_name === 'Електропостачання') {
              response.data.splice(i, 1);
            }
          }
          for (let i = 0; i < response.data.length; i++) {
            if(response.data[i].company_name.includes("Нафтогаз") === true){
              store.commit("Payment/SET_GAS_LS", response.data[i].service_account);
            }
            response.data[i].checked = false;
            if(response.data[i].balance > 0){
              total += response.data[i].balance;
              response.data[i].checked = true;
            }
          }
          console.log(JSON.stringify(response.data))
          ctx.commit('SET_TOTAL', total.toFixed(2));
          ctx.commit('SET_BALANCES', response.data)
          store.commit("Api/hideLoader");
          store.commit("Api/hideMessage");
        }).catch((error)=> {
          console.log(error)
        })
  },
  storeNewAcont({ state }, callBackFn) {
    Account.storeAccount(state.accountNumber, (res) => {
      console.log(JSON.stringify(res))
      callBackFn(res);
    });
  },
  storeNewAcontEic({ state }, callBackFn) {
    Account.storeAccountEic(state.accountNumber, (res) => {
      callBackFn(res);
    });
  },
  newNativeData({ state, commit }) {
    Account.nativeAuth(state.nativeData).then((response) => {
      console.log(JSON.stringify(response.data))
      commit("SET_AUTH_TOKEN", response.data.access_token);
      commit("SET_USER_STATUS", response.data.status);
      commit("SET_USER_SHARE_STATUS", response.data.share_status);
      commit("SET_USER_ID", response.data.user_id);
      console.log("USER SHARE STATUS : " + response.data.share_status)
      router.push({
        name: "Home",
      });
    });
  },
  newGoogleAuth({ state }, callBackFn) {
    Account.googleAuth(state.nativeData, (res) => {
      callBackFn(res);
    }).then(() => {
      location.reload();
    });
  },
  deleteUserAccount({ dispatch }, accountNumber) {
    return Account.deleteAccountByNumber(accountNumber, () => {
      dispatch("getUserAccounts");
    });
  },
  deleteUser(callBackFn){
    return Account.deleteUser((res) => {
      callBackFn(res);
    })
        .then( () => {
          this.$forceUpdate();
        });
  },
  getUserLanguage({ commit }) {
    return Settings.getLanguage((response) => {
      return commit("SET_LOCALE", response);
    });
  },
  guestMode(guest, cb) {
    return api.put("settings/set-guest", { guest: guest }, cb);
  },
  getGuestMode(callBackFn) {
    return api.get("settings/guest", callBackFn);
  },
  async getSubscriptionStatus({ commit }) {
    await Account.getSubscriptionStatus((response) => {
      if(response.status === 0){
        commit("SET_USER_STATUS_SUB", 0);
      }
      else{
        commit("SET_USER_STATUS_SUB", 1);
      }
      localStorage.setItem("user_status", response.status);
      return commit("SET_USER_STATUS", response.status)
    })
  }
};
